import { h } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/hooks';

import disableScroll from '../../utils/disableScroll';
import useWindowSize from '../../utils/windowSize';

import './sidebar.scss';

const Sidebar = ({
    isHeaderUp,
    products,
    categories,
    categoryFilters,
    setCategoryFilters,
    sortOptions,
    sortFilter,
    setSortFilter,
    priceFilter,
    setPriceFilter,
    resultCount
}) => {
    // States
    const [showSidebar, setShowSidebar] = useState();

    const { width: windowWidth } = useWindowSize();
    const isTablet = windowWidth <= 1024;

    useEffect(() => {
        // Set state for sidebar depending on window width
        if (isTablet) setShowSidebar(false);
        else setShowSidebar(true);
    }, [windowWidth]);

    useEffect(() => {
        // Add another event listener to price range slider for consistency
        const range = document.querySelector('.ws-filter-price-range-slider-range');
        const value = document.querySelector('.ws-filter-price-range-slider-values');

        if (range && value) {
            value.innerHTML = range.value;

            range.addEventListener('input', e => {
                value.innerHTML = range.value;
            });
        }

        // Disable scroll when sidebar is open
        if (showSidebar && isTablet) {
            disableScroll.on();
        } else {
            disableScroll.off();
        }
    }, [showSidebar]);

    // JSX for 1024px and dowm
    if (isTablet)
        return (
            <div className="ws-shop-area-sidebar">
                {isTablet && (
                    <div className="ws-shop-area-sidebar-mobile">
                        <button
                            className="sidebar-mobile-button"
                            onClick={() => setShowSidebar(!showSidebar)}
                        >
                            <span className="material-symbols-outlined">tune</span>
                            <span>Vis filter</span>
                        </button>
                        <div className={`ws-sidebar-filter-mobile ${showSidebar ? 'show' : ''}`}>
                            <span
                                className="ws-filter-mobile-exit-button material-symbols-outlined"
                                onClick={() => setShowSidebar(!showSidebar)}
                            >
                                close
                            </span>
                            <div className="ws-sidebar-filter-mobile-inner">
                                <div className="ws-filter-category">
                                    <h6 className="ws-filter-category-title">Kategori</h6>
                                    <div className="ws-filter-category-checkbox">
                                        {categories.map(category => {
                                            // Count filtered products in each category and display number
                                            const productCount = products
                                                .filter(product => product.catName === category)
                                                .filter(p => p.price >= priceFilter).length;

                                            // Capitalize first letter of category label
                                            const label =
                                                category.charAt(0).toUpperCase() +
                                                category.slice(1);

                                            return (
                                                <label
                                                    className="ws-category-checkbox-item"
                                                    key={category}
                                                >
                                                    <input
                                                        className="ws-checkbox-item-input"
                                                        type="checkbox"
                                                        checked={categoryFilters.has(category)}
                                                        onChange={e =>
                                                            setCategoryFilters(
                                                                e.target.checked,
                                                                category
                                                            )
                                                        }
                                                    />
                                                    {label}
                                                    <span className="ws-checkbox-item-count">
                                                        &nbsp;({productCount})
                                                    </span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="ws-filter-sort">
                                    <h6 className="ws-filter-sort-title">Sorter etter</h6>
                                    <div className="ws-filter-sort-radio">
                                        {sortOptions.map(option => {
                                            return (
                                                <label
                                                    htmlFor={`sort-${option.key}`}
                                                    className="ws-sort-radio-item"
                                                    key={option.key}
                                                >
                                                    <input
                                                        className="ws-radio-item-input"
                                                        type="radio"
                                                        name="sort"
                                                        id={`sort-${option.key}`}
                                                        checked={sortFilter === option.key}
                                                        onChange={() => setSortFilter(option.key)}
                                                    />
                                                    {option.value}
                                                </label>
                                            );
                                        })}
                                    </div>
                                </div>
                                {/* Price-range filter - Mobile */}
                                {/* <div className="ws-filter-price-range">
                                    <h6 className="ws-filter-price-range-title">Fra kr</h6>
                                    <div className="ws-filter-price-range-slider">
                                        <input
                                            className="ws-filter-price-range-slider-range"
                                            type="range"
                                            value={priceFilter}
                                            min="0"
                                            max="1000"
                                            step="50"
                                            onChange={e => setPriceFilter(e.target.value)}
                                        />
                                        <span className="ws-filter-price-range-slider-values" />
                                    </div>
                                </div> */}
                            </div>
                            <button
                                className="ws-filter-mobile-results-button sidebar-mobile-button"
                                onClick={() => setShowSidebar(!showSidebar)}
                            >
                                Vis {resultCount} resultat{resultCount !== 1 && 'er'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );

    // JSX for 1024px and up
    return (
        <div className="ws-shop-area-sidebar">
            <div className={`ws-sidebar-filter ${isHeaderUp && 'header-up'}`}>
                <div className="ws-filter-category">
                    <h6 className="ws-filter-category-title">Kategori</h6>
                    <div className="ws-filter-category-checkbox">
                        {categories.map(category => {
                            // Count filtered products in each category and display number
                            const productCount = products
                                .filter(product => product.catName === category)
                                .filter(p => p.price >= priceFilter).length;

                            // Capitalize first letter of category label
                            const label = category.charAt(0).toUpperCase() + category.slice(1);

                            return (
                                <label className="ws-category-checkbox-item" key={category}>
                                    <input
                                        className="ws-checkbox-item-input"
                                        type="checkbox"
                                        checked={categoryFilters.has(category)}
                                        onChange={e =>
                                            setCategoryFilters(e.target.checked, category)
                                        }
                                    />
                                    {label}
                                    <span className="ws-checkbox-item-count">
                                        &nbsp;({productCount})
                                    </span>
                                </label>
                            );
                        })}
                    </div>
                </div>
                <div className="ws-filter-sort">
                    <h6 className="ws-filter-sort-title">Sorter etter</h6>
                    <div className="ws-filter-sort-radio">
                        {sortOptions.map(option => {
                            return (
                                <label
                                    htmlFor={`sort-${option.key}`}
                                    className="ws-sort-radio-item"
                                    key={option.key}
                                >
                                    <input
                                        className="ws-radio-item-input"
                                        type="radio"
                                        name="sort"
                                        id={`sort-${option.key}`}
                                        checked={sortFilter === option.key}
                                        onChange={() => setSortFilter(option.key)}
                                    />
                                    {option.value}
                                </label>
                            );
                        })}
                    </div>
                </div>
                {/* Price-range filter - Desktop */}
                {/* <div className="ws-filter-price-range">
                    <h6 className="ws-filter-price-range-title">Fra kr</h6>
                    <div className="ws-filter-price-range-slider">
                        <input
                            className="ws-filter-price-range-slider-range"
                            type="range"
                            value={priceFilter}
                            min="0"
                            max="1000"
                            step="50"
                            onChange={e => setPriceFilter(e.target.value)}
                        />
                        <span className="ws-filter-price-range-slider-values" />
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Sidebar;
